import React from 'react';
import './posts-loader.component.scss';

/** Renders posts loader component */
export default function PostsLoaderComponent() {
	return (
		<div className="loader">
			<div className="la-square-jelly-box la-dark la-3x">
				<div></div>
				<div></div>
			</div>
		</div>
	);
}
